import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import PropTypes from 'prop-types';

import config from '../../config';

class Payment extends React.Component {
  componentDidMount() {}

  render() {
    const { onSelectedPaymentMethod, selectedPaymentMethod, finalPrice } = this.props;

    return (
      <div>
        <div className="create-order-section-header">
          <Typography variant="h6">
            Sposób płatności
          </Typography>
        </div>
        <FormControl component="fieldset">
          <RadioGroup
            name="paymentMethod"
            value={selectedPaymentMethod}
            onChange={onSelectedPaymentMethod}
          >
            <FormControlLabel value={config.paymentMethods.online} control={<Radio />} label="Płatność online" />
            <FormControlLabel value={config.paymentMethods.cash} control={<Radio />} label="Gotówka" />
          </RadioGroup>
        </FormControl>
        {!!finalPrice && (
          <div className="create-order-section-header">
            <Typography variant="h6">
              Do zapłaty:
            </Typography>
            {finalPrice}
            {' '}
            zł
          </div>
        )}
      </div>
    );
  }
}

Payment.propTypes = {
  onSelectedPaymentMethod: PropTypes.func.isRequired,
  selectedPaymentMethod: PropTypes.string.isRequired,
  finalPrice: PropTypes.number,
};

Payment.defaultProps = {
  finalPrice: undefined,
};

export default Payment;
